import type { SupabaseClient } from '@supabase/supabase-js'
import type { IDomainEventBus } from '../../../application/port/out/IDomainEventBus'
import type { DomainEvent } from '../../../domain/events/DomainEvent'

// Persists domain events to the `domain_events` table for audit/observability.
// Enable via VITE_DOMAIN_EVENTS_PERSIST=true in .env.local.
// The INSERT is fire-and-forget: if it fails the main operation is unaffected.
export class SupabasePersistentDomainEventBus implements IDomainEventBus {
  constructor(private readonly supabase: SupabaseClient) {}

  async dispatch(events: DomainEvent[]): Promise<void> {
    if (!events.length) return

    for (const event of events) {
      console.debug(`[DomainEvent] ${event.eventType}`, { id: event.aggregateId, at: event.occurredAt })
    }

    // Persist non-blocking — a write failure must never break the main flow
    this.supabase
      .from('domain_events')
      .insert(
        events.map((e) => ({
          event_id:     e.eventId,
          event_type:   e.eventType,
          aggregate_id: e.aggregateId,
          payload:      e as unknown as Record<string, unknown>,
          occurred_at:  e.occurredAt.toISOString(),
        })),
      )
      .then(({ error }) => {
        if (error) console.warn('[DomainEvent] persist failed:', error.message)
      })
  }
}
